import { Component, Input, OnInit } from '@angular/core';
import { isArray } from 'util';

@Component({
    selector: 'app-error-message-span',
    templateUrl: './error-message-span.component.html',
    styleUrls: ['./error-message-span.component.scss']
})
export class ErrorMessageSpanComponent implements OnInit {
    @Input() message: string;
    @Input() messages: string[] = [];
    @Input() suggestionsPresent = false;

    transformedMsgs: string[];

    constructor() {
    }

    ngOnInit() {
        const temp = [this.message, ...this.messages];
        this.transformedMsgs = [...temp].reduce(
            (prev, msg) => !!msg ? [...prev, ...(msg.split('\n'))] : prev, []);
    }
}
